import { UserInfo } from "../types/UserInfo";

export const getIndividualInvestorId = (
  userInfo: UserInfo,
): string | undefined => {
  return userInfo.userInvestors.find(
    (investor) => investor.details.investorType === "individual",
  )?.investorId;
};
